export default {

    methods: {
        levelClass(level) {
            const classes = {
                1: 'bad-bg',
                2: 'warning-bg',
                3: 'warning-bg',
                4: 'good-bg',
            };

            return classes[ level ] || classes[ 4 ];
        },

        levelTextClass(level) {
            const classes = {
                1: 'bad-text',
                2: 'warning-text',
                3: 'warning-text',
                4: 'good-text',
            };

            return classes[ level ] || classes[ 4 ];
        },
    }
}



// WEBPACK FOOTER //
// ./resources/js/mixins/LevelsMixin.js